module.exports = __webpack_public_path__ + "img/artbyheart.3fdd0706.png";